import { GET_DASHBOARD } from '../../store/Types';
import { getDashboardService } from './DashboardService';

export const getDashboardAction = async (dispatch, tipo, idEntidad) => {
  try {
    const res = await getDashboardService(tipo, {
      idEntidad,
    });
    if (res.status === 200) {
      dispatch({
        type: GET_DASHBOARD,
        payload: res.data,
      });
      return true;
    }
  } catch (e) {}
};
